export default "__VITE_ASSET__Bz2FT4Ce__"